import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import lo from 'lodash'

import { actionFormatter } from 'molecules/TableFormatters'
import { selectionFormatter } from 'molecules/TableFormatters/selectionFormatter'
import DataTable from 'organisms/DataTable'
import ModalPage from 'templates/ModalPage/index'
import { OUTPIT_RAINFALL_VALIDATIONS } from 'fixtures/api'
import {
  TxtSuccessSubmit,
  TxtFailedSubmitData,
  TxtConfirmDeleteReport,
  TxtSuccessDeleteReport,
  TxtFailedDelete,
} from 'fixtures/texts'
import { getAllCompaniesData } from 'Redux/actions/CompanyListActions'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions'
import { deleteData, postNewData, putData } from 'services/cmsService'
import { TableWrapper } from './styles'
import FormCheck from 'components/atoms/Inputs/FormCheck'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import {
  contractorReportRSDelete,
  contractorReportRSUpdate,
} from 'fixtures/permissions'
import { getAllContractorsData } from 'Redux/actions/ContractorListActions'
import OutpitRainfallModal from 'components/organisms/OutpitRainfallModal/index'

class OutpitRainfallValidation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: lo.cloneDeep(props.data),
      allowUpdate: permissionCheck(
        props.user.permissions,
        contractorReportRSUpdate
      ),
      allowDelete: permissionCheck(
        props.user.permissions,
        contractorReportRSDelete
      ),
      isShowModal: false,
      navList: ['Outpit R/S Validation'],
      modalData: {},
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
    }
  }

  componentDidMount() {
    this.props.onRef(this)
    this.props.getAllCompaniesData()
    this.props.getAllContractorsData()
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props
    if (!lo.isEqual(prevProps.data, data)) {
      this.setState({ data })
    }
  }

  switchModal(row) {
    const { isShowModal } = this.state
    this.setState({ modalData: row }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  addNew = () => {
    const { isShowModal } = this.state
    const { contractorsList, user } = this.props
    const userCompany = 'allowedCompanies' in user ? user.allowedCompanies : []
    this.setState({
      isShowModal: !isShowModal,
      modalData: {
        companyId: userCompany[0] ? userCompany[0].id : null,
        contractorId: contractorsList ? contractorsList[0].id : null,
        pit: '',
        date: new Date(),
        amount: 0,
        rainFrom: new Date(),
        rainTo: new Date(),
        slipperyFrom: null,
        slipperyTo: null,
        totalRain: 0,
        totalSlippery: 0,
        remark: '',
      },
    })
  }

  toggleChecklist = (row, field) => {
    const { data } = this.state
    const newData = data.map((d) =>
      d.id === row.id ? { ...d, [field]: !row[field] } : d
    )
    this.setState({ data: newData })
    this.props.onChecked(row.id)
  }

  toggleAllChecklist = () => {
    const { data } = this.state
    const { isCheckedAll } = this.props
    const newData = data.map((d) => ({ ...d, isChecked: !isCheckedAll }))
    this.setState({ data: newData })
    this.props.onAllChecked(!isCheckedAll ? newData.map((d) => d.id) : [])
  }

  onChangeModalData = (val, field) => {
    const { modalData } = this.state
    modalData[field] = val
    this.setState({ modalData })
  }

  onSubmit = () => {
    const { modalData } = this.state
    const {
      id,
      companyId,
      contractorId,
      pit,
      shiftId,
      date,
      amount,
      rainFrom,
      rainTo,
      slipperyFrom,
      slipperyTo,
      totalRain,
      totalSlippery,
      remark,
    } = modalData
    const uri = id
      ? `${OUTPIT_RAINFALL_VALIDATIONS}/${id}`
      : OUTPIT_RAINFALL_VALIDATIONS

    const form = {
      companyId,
      contractorId,
      pit,
      shiftId,
      date: moment(date).format('YYYY/MM/DD'),
      amount,
      rainFrom: moment(rainFrom).format('YYYY/MM/DD HH:mm'),
      rainTo: moment(rainTo).format('YYYY/MM/DD HH:mm'),
      totalRain,
      ...(!!slipperyFrom && {
        slipperyFrom: moment(slipperyFrom).format('YYYY/MM/DD HH:mm'),
      }),
      ...(!!slipperyTo && {
        slipperyTo: moment(slipperyTo).format('YYYY/MM/DD HH:mm'),
      }),
      totalSlippery: totalSlippery || 0,
      remark,
    }

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const res = id ? await putData(uri, form) : await postNewData(uri, form)
        if (res.status >= 200 && res.status < 300) {
          alert(TxtSuccessSubmit)
          this.props.onRefresh()
          this.setState({
            isShowModal: false,
            modalData: {},
          })
        }
      } catch (error) {
        alert(TxtFailedSubmitData)
      } finally {
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  onDelete = async (data) => {
    const isOk = window.confirm(TxtConfirmDeleteReport)
    if (isOk) {
      const url = `${OUTPIT_RAINFALL_VALIDATIONS}/${data.id}`
      try {
        const res = await deleteData(url)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteReport)
          this.props.onRefresh()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDelete)
      }
    }
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const {
      settingsTable,
      viewState: { isMobileView },
      isCheckedAll,
    } = this.props
    const { data, isShowModal, modalData, isSubmitDisabled, isError, navList } =
      this.state

    const sizePerPage = settingsTable.sizePerPage[navList[0]]
    const isContractor =
      this.props.user.userRole === 'CONTRACTOR' ||
      String(this.props.user.department.name)
        .toLowerCase()
        .includes('contractor')
    const columnConfig = [
      {
        dataField: 'id',
        text: '',
        sort: false,
        headerFormatter: () => (
          <FormCheck
            value={isCheckedAll}
            allowEdit={data && data.length > 0}
            fn={() => this.toggleAllChecklist()}
          />
        ),
        formatter: (cell, row, rowIndex, formatExtraData) =>
          isContractor && row.validatedAt
            ? null
            : selectionFormatter(cell, row, rowIndex, formatExtraData),
        formatExtraData: {
          allowEdit: true,
          field: 'isChecked',
          fn: (row, field) => this.toggleChecklist(row, field),
        },
        headerAttrs: { width: isMobileView ? 200 : 500 },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true,
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 100 : 150 },
        headerStyle: { minWidth: '75px' },
        formatter: actionFormatter,
        formatExtraData: {
          style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          },
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          isContractor,
          edit: (row) => this.switchModal.bind(this, row),
          del: (row) => this.onDelete.bind(this, row),
        },
        isDummyField: true,
      },
      {
        dataField: 'companyName',
        text: 'Company',
        headerStyle: { minWidth: '250px' },
        sort: true,
      },
      {
        dataField: 'contractorName',
        text: 'Contractor',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'pit',
        text: 'Pit',
        headerStyle: { minWidth: '150px' },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {typeof cell === 'string'
                ? cell
                : cell && 'name' in cell
                ? cell.name
                : ''}
            </div>
          )
        },
        sort: true,
      },
      {
        dataField: 'date',
        text: 'Date',
        headerStyle: { minWidth: '100px' },
        formatter: (cell) => moment(cell).format('YYYY-MM-DD'),
        sort: true,
      },
      {
        dataField: 'amount',
        text: 'Amount',
        sort: true,
      },
      {
        dataField: 'rainFrom',
        text: 'Rain From',
        headerStyle: { minWidth: '150px' },
        formatter: (cell) => moment(cell).format('YYYY/MM/DD HH:mm'),
        sort: true,
      },
      {
        dataField: 'rainTo',
        text: 'Rain To',
        headerStyle: { minWidth: '150px' },
        formatter: (cell) => moment(cell).format('YYYY/MM/DD HH:mm'),
        sort: true,
      },
      {
        dataField: 'slipperyFrom',
        text: 'Slippery From',
        headerStyle: { minWidth: '150px' },
        formatter: (cell) =>
          cell ? moment(cell).format('YYYY/MM/DD HH:mm') : '-',
        sort: true,
      },
      {
        dataField: 'slipperyTo',
        text: 'Slippery To',
        headerStyle: { minWidth: '150px' },
        formatter: (cell) =>
          cell ? moment(cell).format('YYYY/MM/DD HH:mm') : '-',
        sort: true,
      },
      {
        dataField: 'totalRain',
        text: 'Total Rain',
        headerStyle: { minWidth: '120px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'totalSlippery',
        text: 'Total Slippery',
        headerStyle: { minWidth: '120px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'remark',
        text: 'Remark',
        headerStyle: { minWidth: '150px' },
        sort: true,
      },
      {
        dataField: 'validatedAt',
        text: 'Validated At',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {row.validatedAt
                ? moment(row.validatedAt).format('DD/MM/YYYY - h:mm A')
                : '-'}
            </div>
          )
        },
        headerStyle: { minWidth: '200px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'validatedBy',
        text: 'Validated By',
        headerStyle: { minWidth: '150px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'mmStatus',
        text: 'MM Status',
        headerStyle: { minWidth: '150px' },
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell) => {
          return cell ? cell : '-'
        },
      },
      {
        dataField: 'mmRemark',
        text: 'MM Remarks',
        headerStyle: { minWidth: '350px' },
        sort: true,
      },
    ]

    return (
      <React.Fragment>
        <TableWrapper>
          <DataTable
            isMobile={isMobileView}
            fnEdit={this.fnEdit}
            dataList={data}
            columnConfig={columnConfig}
            containerClassName="p-0"
            wrapperClasses="table-responsive"
            isInlineEdit
            sizePerPage={sizePerPage}
            onSizePerPageChange={this.onSizePerPageChange}
          />
        </TableWrapper>

        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          ignoreBackgroundClick
          contentChild={
            <OutpitRainfallModal
              fnChange={this.onChangeModalData.bind(this)}
              fnSubmit={this.onSubmit.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              rainfallData={modalData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              isMobileView={isMobileView}
              {...this.props}
            />
          }
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    companiesList: state.companiesList,
    settingsTable: state.settingsTable,
    user: state.userLogin ? state.userLogin.userDetail : {},
    contractorsList: state.contractorsList,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllCompaniesData,
      getAllContractorsData,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutpitRainfallValidation)
